import { useEffect, useState } from "react";
import { useLocation } from "react-router-dom";
import { findAllImage, findGalleryCategories, findImage } from "../api/apiService";

const Gallery = () => {
  const location = useLocation();
  const catName = location.search.replace('?tab=', '').replace('%20', ' ');
  const [activeTab, setActiveTab] = useState(catName);
  const [selectedImage, setSelectedImage] = useState(null);
  const [isTransitioning, setIsTransitioning] = useState(false);
  const [categories, setCategories] = useState([])

  const handleTabChange = (tab) => {
    if (tab !== activeTab) {
      setIsTransitioning(true);
      setTimeout(() => {
        setActiveTab(tab);
        setIsTransitioning(false);
      }, 200);
    }
  };
  const findData = async () => {
    try {
      const res = await findGalleryCategories();

      const renderImage = async (id) => {
        if (!id) return [];
        const idArray = Array.isArray(id) ? id : [id];
        const idsParam = idArray.join(",");
        const res = await findAllImage(idsParam);
        return res?.data?.[0]?.data || [];
      };

      const newData = await Promise.all(
        (res?.data ?? []).map(async (item) => ({
          ...item,
          categoryImage: await renderImage(item?.categoryImage),
          images: await renderImage(item?.images),
        }))
      );

      setCategories(newData);

    } catch (error) {
      console.error("Error fetching data:", error);
    }
  };

  useEffect(() => {
    setActiveTab(catName.length ? catName : categories[0]?.categoryName);
  }, [categories])

  useEffect(() => {
    findData()
  }, [])
  return (
    <div className=" min-h-screen pt-24 py-12 px-6 md:px-12">

      <h2 className="text-center text-2xl md:text-3xl font-semibold text-[#F37934] mb-6" data-aos="zoom-in"
        data-aos-duration="800"
        data-aos-easing="ease-out">
        GALLERY
      </h2>
      {categories.length > 0 &&
        <>
          <div className="flex justify-center mb-8">
            <div className="flex flex-wrap justify-center w-full gap-2 sm:hidden">
              {categories?.map((tab) => (
                <button
                  key={tab?.categoryName}
                  onClick={() => handleTabChange(tab?.categoryName)}
                  className={`px-4 py-2 text-sm font-medium rounded-full border transition-all duration-300 ${activeTab === tab?.categoryName
                    ? "bg-[#F37934] border-[#F37934] text-white"
                    : "border-[#F37934] text-[#56453F]"
                    }`}
                >
                  {tab?.categoryName}
                </button>
              ))}
            </div>

            <div className="hidden sm:inline-flex flex-wrap justify-center gap-2 sm:gap-4 mb-8 
                  border border-[#F37934] rounded-full px-2 py-2">
              {categories?.map((tab) => (
                <button
                  key={tab?.categoryName}
                  onClick={() => handleTabChange(tab?.categoryName)}
                  className={`px-4 py-2 text-sm sm:text-base font-medium transition-all duration-300 ${activeTab === tab?.categoryName
                    ? "bg-[#F37934] rounded-full text-white"
                    : "text-[#56453F]"
                    }`}
                >
                  {tab?.categoryName}
                </button>
              ))}
            </div>
          </div>
          <div className="w-fit mx-auto">
            <div className={`grid grid-cols-2 sm:grid-cols-2 md:grid-cols-4 gap-10 transition-opacity duration-300 ${isTransitioning ? 'opacity-0' : 'opacity-100'
              }`}>
              {categories?.find(a => a?.categoryName === activeTab)?.images?.map((img, index) => (
                <div key={index} className="overflow-hidden rounded-xl cursor-pointer" data-aos="flip-left"
                  data-aos-duration="800"
                  data-aos-delay={index * 50}
                  onClick={() => setSelectedImage(img)}>
                  <img
                    src={img}
                    alt={`${activeTab}-${index}`}
                    className="w-full h-48 object-cover"
                  />
                </div>
              ))}
            </div>
          </div>
          {selectedImage && (
            <div className="fixed inset-0 z-50 flex items-center justify-center bg-black bg-opacity-70 px-4">
              <div className="relative mx-auto p-6 flex flex-col items-center w-full">
                <img
                  src={selectedImage}
                  alt="Selected"
                  className="
          rounded-xl
          w-full
          max-w-[90vw] sm:max-w-[80vw] md:max-w-[60vw] lg:max-w-[40vw]
          max-h-[50vh] sm:max-h-[55vh] md:max-h-[60vh]
          object-cover
        "
                />

                <button
                  onClick={() => setSelectedImage(null)}
                  className="mt-8 flex items-center gap-2 border border-[#F37934] text-white px-6 py-2 rounded-full text-sm hover:bg-[#d9641f] transition"
                >
                  ✕ <span>Close</span>
                </button>
              </div>
            </div>
          )}
        </>
      }
    </div>
  );
};

export default Gallery;
